export class RRAvatarGeneratorMeassurementsModel {
  id: string;
  value: number;
}
